import React, { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import classNames from "classnames"
import { Menu, User } from "Components/Icons"
import { Dropdown, DropdownMenu, DropdownToggle } from "Components/ReactstrapSlim"
import { SocialVisibilityIndicator } from "Components/SocialVisibilityIndicator"
import { useShadowToggle } from "Hooks"
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import { userSelector } from "Utils/selectors";
import { NewMessageHandler, useCommonHub } from "Utils/CommonHub"
import { newMessagesCountSelector } from "Utils/selectors"
import { modifiers } from "./Header"
import { HeaderDropDownMenu as HeaderUserDropDownMenu } from "./HeaderUserDropDownMenu";
import HeaderMobileAnonymousDropDownMenu from "./HeaderMobileAnonymousDropDownMenu"

interface HeaderUserMenuProps {
   redirectToMyLiquidSpaceAfterSignIn?: boolean;
   // If true, when clicking on menu toggle in mobile layout,dispatch global store state change instead of opening default menu
   dispatchMobileToggle?: boolean;
   onOpen?: () => void;
   isEnterpriseManagment?: boolean;
   mobileUserMenuPortalElement: HTMLElement;
}

export const HeaderUserDropDown: React.FC<HeaderUserMenuProps> = ({
   redirectToMyLiquidSpaceAfterSignIn,
   dispatchMobileToggle,
   onOpen,
   isEnterpriseManagment,
   mobileUserMenuPortalElement }) => {
   const user = useSelector(userSelector);
   const toggleId = "dropdown-toggle-user-ep";

   const newMessagesCount = useSelector(newMessagesCountSelector);
   useEffect(() => {
      dispatch(LSStore.headerMenuCountersThunk());
   }, []);
   const newMessageHandler: NewMessageHandler = useCallback(data => {
      dispatch(LSStore.headerMenuCountersThunk());
   }, []);
   useCommonHub({
      onNewMessage: newMessageHandler
   });

   const [isDropdownOpen, setDropdownOpen] = useState(false);
   const dispatch = useDispatch();
   const toggleMobileMenu = () => {
      dispatch(LSStore.mobileMenuSlice.actions.toggle());
   }

   const isMobile = useMediaBreakpointDown("md");
   const isSmDown = useMediaBreakpointDown("sm");

   const [beforeDropDownOpen, setBeforeDropDownOpen] = useState<string>();

   useEffect(() => {
      if (isDropdownOpen && isMobile) {
         setBeforeDropDownOpen(document.body.style.overflow);
      }

      if (isDropdownOpen && isMobile && document.body.style.overflow === "hidden") {
         document.body.style.overflow = "auto";
      } else if (!isDropdownOpen && isMobile && beforeDropDownOpen) {
         document.body.style.overflow = beforeDropDownOpen;
      }
   }, [isDropdownOpen]);

   useEffect(() => {
      setDropdownOpen(false);
      dispatch(LSStore.mobileMenuSlice.actions.close());
   }, [isMobile]);

   function toggleDropdown() {
      if (isMobile && dispatchMobileToggle) {
         toggleMobileMenu();
      }
      else {
         setDropdownOpen(!isDropdownOpen);
      }
      if (onOpen) {
         onOpen();
      }
   }

   useShadowToggle(toggleId, isDropdownOpen, isEnterpriseManagment);

   return <>
      <Dropdown isOpen={isDropdownOpen} toggle={toggleDropdown}>
         <DropdownToggle id={toggleId} color="secondary" className="header-user-toggle" aria-label="user menu">
            {
               user.isAuthenticated
                  ? <div className="header-avatar header-avatar-sm">
                     {

                        user.imageUrl
                           ? <img src={user.imageUrl} alt={`Photo of ${user.fullName || undefined}`} />
                           : <User />
                     }
                     <SocialVisibilityIndicator className="social-visibility-indicator-avatar-toggle" />
                  </div>
                  : null
            }
            <Menu className={classNames("header-user-toggle-hamburger", { "header-user-toggle-hamburger--anonymous": !user.isAuthenticated })} />
            {
               newMessagesCount
                  ? <div className="header-counter header-user-toggle-counter">{newMessagesCount}</div>
                  : null
            }
         </DropdownToggle>
         {
            isSmDown && !user.isAuthenticated
               ? <HeaderMobileAnonymousDropDownMenu
                  isOpen={isDropdownOpen}
                  redirectToMyLiquidSpaceAfterSignIn={redirectToMyLiquidSpaceAfterSignIn}
                  menuPortalElement={mobileUserMenuPortalElement}
               />
               : <DropdownMenu modifiers={modifiers} right className={classNames("header-user-popup", { "d-none": dispatchMobileToggle && isMobile }, { "header-user-popup-anonymous": !user.isAuthenticated })}>
                  <HeaderUserDropDownMenu
                     redirectToMyLiquidSpaceAfterSignIn={redirectToMyLiquidSpaceAfterSignIn}
                     isEnterpriseManagment={isEnterpriseManagment}
                  />
               </DropdownMenu>
         }
      </Dropdown>
   </>
}